// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12422(12ba674a14)-C08/06/2026-10:57:42-B08/06/2026-11:03:56' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12422(12ba674a14)-C08/06/2026-10:57:42-B08/06/2026-11:03:56",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12422",
  shortHash: "12ba674a14",
  longHash: "12ba674a147a30f81a184f14ea3d3373313cba7d",
  dateCommit: "08/06/2026-10:57:42",
  dateBuild: "08/06/2026-11:03:56",
  buildType: "Ansible",
  } ;
